import React from 'react'
import { guardProps } from './validate'
import { measureText } from 'lib/text'

// Type gets bolder and stops growing in response to the cell height
// after this pixel value
const HEIGHT_LIMIT = 30

// Limit the text growth/shrinking to these values:
const MAX_FONT = 11
const MIN_FONT = 9

class EasingRect extends React.Component {
  static defaultProps = {
    stroke: null,
    strokeWidth: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    padding: 1
  }

  getFontSize() {
    const { height } = this.props

    // This is a bit number fishy, but approximates a "good looking" text
    // size within the rectangle
    return height >= HEIGHT_LIMIT ? MAX_FONT : Math.max(MIN_FONT, height * 0.4)
  }

  getFontWeight() {
    const { height } = this.props

    return height >= HEIGHT_LIMIT ? 'bold' : 'normal'
  }

  canRenderText() {
    const { padding, width, height } = this.props

    let fontSize = this.getFontSize()

    if (fontSize / height > 0.72) {
      return false
    }

    let innerWidth = width - padding * 2

    // What's going on here? We know each rectangle will never have a
    // label longer than 4 characters. We can memoize the calculation
    // and prevent cases where negative numbers (which have a "-",
    // thus are longer) hide when positive numbers complete
    return measureText('-1.00', `${fontSize}px sans-serif`) / innerWidth < 0.9
  }

  render() {
    const {
      fill,
      stroke,
      strokeWidth,
      padding,
      label,
      x,
      y,
      width,
      height,
      opacity
    } = this.props

    if (guardProps(this, 'x', 'y', 'width', 'height')) {
      return null
    }

    const fontSize = this.getFontSize()
    const fontWeight = this.getFontWeight()

    const renderWidth = Math.max(0, width - padding * 2)
    const renderHeight = Math.max(0, height - padding * 2)

    const showText = this.canRenderText()

    return (
      <g className="easing-rect" fill={fill} stroke={stroke}>
        <title>{label}</title>

        <rect
          x={x + padding}
          y={y + padding}
          width={renderWidth}
          height={renderHeight}
          strokeWidth={strokeWidth}
          opacity={opacity}
        />

        <text
          x={x + width * 0.5}
          y={y + height * 0.5}
          fontSize={`${fontSize}px`}
          fontWeight={fontWeight}
          textAnchor="middle"
          strokeWidth="0"
          dominantBaseline="central"
          shapeRendering="crispEdges"
          opacity={showText ? 1 : 0}
          stroke="none"
          fill="#fff"
        >
          {label}
        </text>
      </g>
    )
  }
}

export default EasingRect



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-rect.js